module.exports = __webpack_public_path__ + "static/media/6540.5790ba7f.jpg";